import { generateButtonToggle } from '@js/modules/floatingButton/index';

const buttonToggle = generateButtonToggle('.top-round-button--floating', '.top-contents', '.footer');
window.addEventListener('load', buttonToggle);
window.addEventListener('scroll', buttonToggle);
